import { isEmpty } from 'lodash';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { DepositContext } from '../../../../../../types/Cashier';
import SuggestedPayments from '../../../../../SuggestedPayments/SuggestedPayments';
import useSuggestedPaySystems from '../../../../hooks/useSuggestedPaySystems';

import { wrapper } from './RejectedTranscation.scss';

type Props = DepositContext & { transactionId: string };

const RejectedTransaction: React.FC<Props> = ({ deposit, transactionId }) => {
  const {
    data: { paySystems, depositResultContext }
  } = useWizardContext();
  const { type } = deposit || depositResultContext || {};
  const suggestedPayments = useSuggestedPaySystems(type, transactionId);
  return (
    <>
      {!isEmpty(suggestedPayments) && !isEmpty(paySystems) && (
        <div className={wrapper}>
          <SuggestedPayments paySystems={paySystems} suggestedPayments={suggestedPayments} />
        </div>
      )}
    </>
  );
};

export default RejectedTransaction;
